import React from 'react';
import { useTranslation } from 'react-i18next';
import { setShowInfoModal } from '../../store/redux/slices/productFactorySlice';
import { useDispatch } from 'react-redux';

// Components
import { VStack, Text, Link } from '@wegroup/design-system';

const CampaignsSignedOfferBottomContainer: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onHereClick = () => dispatch(setShowInfoModal(true));

  return (
    <VStack align="left" width="100%">
      <Text as="h5" textStyle="h5Headline">
        {t('Have any more questions?')}
      </Text>
      <Text color="text.gray" pb="6">
        {t('Feel free to contact your broker')}{' '}
        <Link onClick={onHereClick}>{t('here')}</Link>{' '}
        {t(
          'to ask them any more questions you might have in concern to these offers',
        )}
      </Text>
    </VStack>
  );
};

export default CampaignsSignedOfferBottomContainer;
